export default []

/*
  {
    guards: {
      auth: [
        {
          path: '/auth',
          name: 'welcomeauth',
          component: require('../pages/welcome/index.vue'),
          meta: {heading: 'welcome'},
        },
      ]
      guest: []
    },
    routes: [
      {
        path: '/',
        name: 'welcomeauth2',
        component: '../pages/welcome/index.vue',
        meta: {heading: 'welcome'},
        guards: ['auth']
      },
      {
        path: '/guest',
        name: 'welcomeguest',
        component: require('../pages/welcome/index.vue'),
        meta: {heading: 'welcome'},
        guards: ['guest']
      }
    ],
  }
*/
